export default __webpack_public_path__ + "static/media/Animations_Cog3.aae969b1.svg";